// extracted by mini-css-extract-plugin
module.exports = {"heading":"AgritourismStatutesPage_heading__1qvXO","content":"AgritourismStatutesPage_content__cebHl"};